import {
  isAnalyticsEnabled,
  addToCartMainEvent,
  addToCartRelatedProductsEvent,
  productSelectorVirtualPageEvent,
  removeFromFavoritesEvent,
  send,
  GlobalAnalyticsEventDetails
} from "@pes-ui/utils";
import * as constants from "../constants/constants";

export const sendAnalytics = ({
  responseData: { infoForGa, productsUpdated: productIds },
  quantity,
  eventType,
  productData,
  addProductsFromProductSelector = false,
  parentSkuId,
  additionalData = null,
}) => {
  if (!isAnalyticsEnabled()) return;

  const { currencyCode, productList } = processProductData(productData, productIds, infoForGa, quantity, parentSkuId);
  const gaEventPayload = {
    currencyCode,
    products: productList,
  };
  const gaValues = getGAEventPayload(eventType, additionalData);

  if (!gaValues) {
    console.error('Could not generate GA event payload');
    return;
  };

  const { eventName, payload = {} } = gaValues;
  send(eventName as any, { ...gaEventPayload, ...payload } as GlobalAnalyticsEventDetails);
    
  if (!addProductsFromProductSelector) return;
  send(productSelectorVirtualPageEvent);
};

export const getGroupProductsData = (products, quantity) => {
  return products.reduce(
    (result, product) => {
      result.productId.push(product.ID);
      result.productQty.push(quantity);

      return result;
    },
    {
      productId: [],
      productQty: [],
    }
  );
}

const processProduct = (id: string, quantity: number, gaObject: any, parentSkuId: string): any => {
  const { brand = '', description, price = null } = gaObject;
  const productQty = quantity === 0 ? 1 : Math.abs(quantity);

  return {
    brand,
    price: price || '',
    category: '',
    id,
    name: description,
    quantity: productQty,
    variant: parentSkuId || '',
  };
};

const processProductData = (productData, productIds, infoForGa, quantity, parentSkuId): { currencyCode: string, productList: any[] } => {
  if (productData.type && productData.type === constants.groupType.GROUP) {
    const groupProductData = productData?.products ? getGroupProductsData(productData?.products, quantity) : productData;
    const currencyCode = infoForGa[groupProductData.productId[0]]?.currency;
    const productList = groupProductData.productId.map(
      (id: string, index: number) => processProduct(id, groupProductData.productQty[index], infoForGa[id], parentSkuId)
    );

    return {
      currencyCode,
      productList
    };
  }

  if (!productIds?.length) {
    productIds = productData.productId;

    const productQty = productData.productQty;
    const currencyCode = infoForGa[productIds[0]]?.currency;
    const productList = productIds.map(
      (id: string, index: number) => processProduct(id, productQty[index], infoForGa[id], parentSkuId)
    );
    return {
      currencyCode,
      productList
    };
  }
  
  const currencyCode = infoForGa[productIds[0]]?.currency;
  const productList = productIds.map((id: string) => processProduct(id, quantity, infoForGa[id], parentSkuId));

  return {
    currencyCode,
    productList
  };
}

const getGAEventPayload = (eventType, additionalData) => {
  switch (eventType) {
    case constants.ADD:
      return {
        eventName: addToCartMainEvent,
        payload: {
          distributor: '',
          addToCartLocation: additionalData?.gaLocation,
        },
      };
    case constants.REMOVE:
      return { eventName: removeFromFavoritesEvent };
    case constants.ADD_FROM_RELATED_PRODUCT:
      return {
        eventName: addToCartRelatedProductsEvent,
        payload: {
          distributor: '',
          addToCartLocation: additionalData?.gaLocation,
        },
      };
    default: return null;
  }
}
